module.exports = __webpack_public_path__ + "static/media/rea-gen.9616f6d1.png";